// Single source of truth for Notification.type - mirrors exerciseBlockTypes.js's
// convention (one object per value: code the backend stores, label shown in
// CRM, accent color for badges).
export const NOTIFICATION_TYPES = {
   INFO: {
      code: 'INFO', label: 'Інформаційне', accent: '#7ec2e8',
      hint: 'Студент просто побачить це - підтвердження не потрібне.',
   },
   ACK_REQUIRED: {
      code: 'ACK_REQUIRED', label: 'Потребує підтвердження', accent: '#e0a35c',
      hint: 'Студент має натиснути "Ознайомлений(-а)" - без цього повідомлення лишається непідтвердженим.',
   },
   BLOCKING: {
      code: 'BLOCKING', label: 'Обов’язкове', accent: '#e0533a',
      hint: 'Показується одразу після входу на платформу і блокує подальшу роботу, доки студент не підтвердить (або не вийде з акаунту).',
   },
};

export const NOTIFICATION_TYPE_LIST = Object.values(NOTIFICATION_TYPES);

export function getNotificationType(code) {
   return NOTIFICATION_TYPES[code] || null;
}
